package info.rezident.app.ui.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import info.rezident.app.ui.theme.AppTheme
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun InformationalNote(
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .backgroundColor(Color.transparent)
            .borderRadius(AppTheme.shapes.mediumRound)
            .padding(16.px)
            .border(1.px, LineStyle.Solid, AppTheme.colors.accent)
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.px)
        ) {
            SpanText(
                text = "💡",
                modifier = Modifier.fontSize(20.px)
            )
            SpanText(
                text = "Scorul de Potrivire este calculat pe baza răspunsurilor tale.",
                modifier = AppTheme.typography.body2.toModifier()
                    .color(AppTheme.colors.textSecondary)
                    .lineHeight(1.4)
            )
        }
    }
}
